import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { Account } from './components/auth/Accounts';
import { BlackflyAPIKey } from './components/contexts/Blackfly';
import { WIntProvider } from './components/contexts/WInt';
import * as serviceWorker from './serviceWorker';

import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/stylesheets/font.css';
import './assets/stylesheets/index.css';


const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Nunito',
      'Roboto',
      'sans-serif'
    ].join(','),
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Account>
      <BlackflyAPIKey>
      <WIntProvider>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </WIntProvider>
      </BlackflyAPIKey>
    </Account>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
